import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-mobile-base-route',
  templateUrl: './mobile-base-route.component.html',
  styleUrl: './mobile-base-route.component.scss',
  imports: [RouterOutlet],
})
export class MobileBaseRouteComponent {}
